<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><span class="l-pageLabel">お問い合わせ</span>新規お問い合わせ</h1>
      <div class="l-btn-title-right-pos">
        <div class="btn-basic-small" @click="goInquiryList()"><a>一覧へ戻る</a></div>
      </div>
      <div class="l-contentsBox">
        <table class="l-form-table">
          <caption>お問い合わせ内容</caption>
          <tr>
            <th class="v-middle"><span>ご用件を選択してください</span></th>
            <td class="v-middle">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.inputForm.$model.inquiryKbn"
                  name="inputForm.mail_send_kbn"
                  :options="selectInquiryKbnList"
                  :selectedValue="inputForm.inquiryKbn"
                  @input="$v.inputForm.$touch()"></SelectBox>
              </div>
              <ValidationErrorMessage v-show="$v.inputForm.inquiryKbn.$error && !$v.inputForm.inquiryKbn.required" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>お問い合わせ内容</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextArea v-model="$v.inputForm.$model.inquiry" @input="$v.inputForm.$touch()" class="l-formGroup__textArea" />
              </div>
              <ValidationErrorMessage v-show="$v.inputForm.inquiry.$error && !$v.inputForm.inquiry.required" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>添付ファイル</span></th>
            <td class="v-middle">
              <input type="file" v-on:change="fileSelected" style="padding-left: 20px;">
            </td>
          </tr>
        </table>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()" :disabled="isProcessing"><a>登録</a></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import SelectBox from '@/components/parts/form/SelectBox.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import constant from '@/const';
import { required } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';

export default {
  components: {
    Loading,
    SelectBox,
    TextArea,
    ValidationErrorMessage,
  },
  data() {
    return {
      isProcessing: false,
      inputForm: {
        inquiryKbn: 1,
        inquiry: '',
      },
      file: {
        fileNm: ''
      },
      fileInfo: '',
      selectInquiryKbnList: constant.INQUIRY_KBN,
    }
  },
  validations: {
    inputForm: {
      inquiryKbn: { required },
      inquiry: { required },
    },
  },
  computed: {
    inquiryId() {
      return this.$store.getters['portal/getInquiryId'];
    }
  },
  created: function() {
  },
  methods: {
    fileSelected(event) {
      this.fileInfo = event.target.files[0];
    },
    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        const formData = new FormData()
        formData.append('file', this.fileInfo)
        formData.append('inquiry', JSON.stringify(this.inputForm))
        if (this.inquiryId) {
          formData.append('inquiryId', this.inquiryId);
        }
        let res = await this.$axios.post('/ld/api/inquiry/store', formData);
        if (res.status === 200) {
          this.$store.dispatch('alert/setMessage', '登録が完了しました');
          this.$router.push({ name: 'inquiry-list' });
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    goInquiryList() {
      const params = {};
      this.$router.push({ name: 'inquiry-list', params: params });
    },
  }
}


</script>